import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Tooltip } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, InfoCircleOutlined } from "@ant-design/icons";

const CustomAgGridHeader = (props) => {
  const colId = props.column.getColId();
  const { tooltip, disableSortingMenu, showSortIcon, hideHeaderMenu } = props;
  const [sort, setSort] = useState(props.column.getSort());
  const sortIcon = showSortIcon ? (
    sort === "asc" ? (
      <ArrowUpOutlined style={{ marginRight: 8, color: "#52c41a", fontSize: 16 }} />
    ) : sort === "desc" ? (
      <ArrowDownOutlined style={{ marginRight: 8, color: "#ff4d4f", fontSize: 16 }} />
    ) : null
  ) : null;

  useEffect(() => {
    const handleSortChanged = () => {
      setSort(props.column.getSort());
    };

    handleSortChanged();
    props.column.addEventListener?.("sortChanged", handleSortChanged);

    return () => {
      props.column.removeEventListener?.("sortChanged", handleSortChanged);
    };
  }, [props.column]);

  const sortAsc = () => {
    props.columnApi.applyColumnState({
      state: [{ colId, sort: "asc" }],
      defaultState: { sort: null },
    });
  };

  const sortDesc = () => {
    props.columnApi.applyColumnState({
      state: [{ colId, sort: "desc" }],
      defaultState: { sort: null },
    });
  };

  const clearSort = () => {
    props.columnApi.applyColumnState({
      state: [{ colId, sort: null }],
      defaultState: { sort: null },
    });
  };

  const resetWidth = () => {
    const colDef = props.column.getColDef();
    const minWidth = colDef.minWidth || 120;

    props.columnApi.setColumnWidth(colId, minWidth);

    props.setSelectedColumns((prev) => {
      const updated = prev.map((col) => (col.dataIndex === colId ? { ...col, width: minWidth } : col));
      if (props.debouncedSaveColumnWidths) {
        props.debouncedSaveColumnWidths(props.dispatch, updated, props.pinnedCount || 0);
      }
      return updated;
    });
  };

  const menu = (
    <Menu>
      {!disableSortingMenu && (
        <>
          {sort === "asc" ? (
            <Menu.Item key="clearAsc" onClick={clearSort}>
              Clear Sorting
            </Menu.Item>
          ) : (
            <Menu.Item key="asc" onClick={sortAsc}>
              Sort Ascending
            </Menu.Item>
          )}
          {sort === "desc" ? (
            <Menu.Item key="clearDesc" onClick={clearSort}>
              Clear Sorting
            </Menu.Item>
          ) : (
            <Menu.Item key="desc" onClick={sortDesc}>
              Sort Descending
            </Menu.Item>
          )}
          <Menu.Divider />
        </>
      )}
      <Menu.Item key="resetWidth" onClick={resetWidth}>
        Reset Width
      </Menu.Item>
    </Menu>
  );
  return (
    <div
      className="custom-ag-grid-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
        padding: "0 4px",
        cursor: "grab",
      }}
    >
      <div className="custom-ag-grid-header-title" style={{ display: "flex", alignItems: "center" }}>
        <span>{props.displayName}</span>
        {tooltip && (
          <Tooltip title={tooltip} placement="top" overlayInnerStyle={{ backgroundColor: "#f0f0f0", color: "#000" }}>
            <InfoCircleOutlined style={{ marginLeft: 8, cursor: "pointer" }} />
          </Tooltip>
        )}
      </div>

      {!hideHeaderMenu ? (
        <>
          {sortIcon}
          <Dropdown overlayClassName="custom-aggrid-header-dropdown" overlay={menu} trigger={["click"]}>
            <button className="custom-header-menu-button" onClick={(e) => e.stopPropagation()}>
              ⋮
            </button>
          </Dropdown>
        </>
      ) : null}
    </div>
  );
};

export default CustomAgGridHeader;
